import { Slide } from "@jelly/lesson";
import config from "appConfig";

import { task as task01 } from "../../../../../task/course-01/lesson-05/task-01";

const task: Slide = {
  title: "Determine the SWR of the reflection coefficient.",
  description: "Fill in the value.",
  layout: {
    type: "table",
    options: {
      cols: 1,
      rows: 2,
      rowsSize: [4, 1],
      components: [
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "image",
                options: {
                  src: `${config.ASSETS_URL}/01/05/task/task-1.svg`,
                },
              },
            },
          },
        ],
        [
          {
            variant: "__task__",
            data: {
              id: task01.id,
            },
          },
        ],
      ],
    },
  },
};

export default task;
